import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import classNames from 'classnames'

import styles from './Step.module.scss'
import KP5CONSTANTS from '../../utils/constants'
import { useTranslation } from 'react-i18next'

const Step = ({
  isInvited,
  isSubAdminPath,
  productParam,
  numberOfSteps,
  currentStep,
  currentStepText,
  progressPercentage
}) => {
  const { t } = useTranslation('common')
  const isHiddenRegistrationPath =
    isInvited ||
    isSubAdminPath ||
    KP5CONSTANTS.REGISTER_PRODUCTS_WITH_HIDDEN_PATHS.HIDDEN.includes(productParam)

  const steps = []
  const textArr = ['Work email', 'Samsung Account', 'Company Info', 'Agreement']
  const startStep = isHiddenRegistrationPath ? 0 : 1 // For MSP/KDP and sub-admin registration, work email should still be displayed so it should start with 0

  for (let i = startStep; i < numberOfSteps; i++) {
    let stepContent = ''
    let state = ''

    if (currentStep == i + 1) {
      state = 'active'
    } else if (currentStep > i + 1) {
      state = 'visited'
    }

    stepContent = (
      <div className={classNames(styles.stepWrapper, state)} key={`step-wrapper-${i}`}>
        <div className={classNames(styles.stepItem, state)}>
          <span className="d-flex align-items-center justify-content-center mx-auto h-100">
            {isHiddenRegistrationPath ? i + 1 : i}
          </span>
          {state == 'active' ? (
            <span className={styles.stepText}>{t(textArr[i])}</span>
          ) : (
            <span className={classNames(styles.stepText)}>{t(textArr[i])}</span>
          )}
        </div>
      </div>
    )

    steps.push(stepContent)
  }

  return (
    <Container className={styles.progressContainer}>
      <Row>
        <Col>
          <div
            className={classNames(styles.progressWrapper, 'mx-md-auto', {
              [styles.withWorkEmail]: isHiddenRegistrationPath
            })}
          >
            <div
              className={styles.progressBar}
              role="progressbar"
              style={{ width: progressPercentage + '%' }}
              aria-valuenow={progressPercentage}
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
            <div className={classNames(styles.stepsWrapper, 'd-flex', 'justify-content-between')}>
              {steps}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default Step
